export default [
  { type: 'rent', price: 0.01, enabled: false, period: 24 },
  { type: 'sale', price: 0.01, enabled: false, period: 0 },
];



// WEBPACK FOOTER //
// ./src/transport/constants/free-deal-info.js